var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgV(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00e597",
    fillRule: "evenodd",
    d: "M5.436 13L.498 8.049C.177 7.727 0 7.299 0 6.844c0-.455.177-.883.498-1.205.663-.664 1.741-.664 2.404 0l2.534 2.54L13.098.5C13.419.177 13.846 0 14.3 0c.454 0 .881.177 1.202.5.321.32.498.749.498 1.204 0 .455-.177.883-.498 1.205L5.436 13z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgV);
export default __webpack_public_path__ + "static/media/v.9f4fe6be.svg";
export { ForwardRef as ReactComponent };